module.exports = __webpack_public_path__ + "img/38.31b986df.png";